/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Loading_From_StorageInputs */



/**
* | output |
* | --- |
* | "Loading tournaments from local storage." |
*
* @param {Tournaments_Loading_From_StorageInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_loading_from_storage = /** @type {((inputs?: Tournaments_Loading_From_StorageInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Loading_From_StorageInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement des tournois depuis le stockage local.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando torneos del almacenamiento local.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Carregando torneios do armazenamento local.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento tornei dall'archivio locale.")
	return /** @type {LocalizedString} */ ("Loading tournaments from local storage.")
});